var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCallPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.65 16.326c1.281 0 2.123-.344 2.863-1.179.059-.058.117-.124.169-.183.44-.49.644-.974.644-1.435 0-.528-.307-1.019-.96-1.473l-2.13-1.48c-.66-.453-1.429-.505-2.044.103l-.564.564c-.169.169-.315.176-.476.074-.396-.25-1.194-.945-1.736-1.487-.571-.564-1.12-1.194-1.414-1.656-.095-.168-.087-.307.081-.476l.557-.564c.615-.615.564-1.391.11-2.043L6.27 2.96c-.454-.652-.945-.952-1.472-.96-.462-.007-.945.205-1.436.645-.066.058-.124.11-.183.16C2.344 3.554 2 4.396 2 5.663c0 2.095 1.29 4.644 3.655 7.01 2.35 2.35 4.907 3.654 6.994 3.654zm.007-1.128c-1.868.037-4.263-1.399-6.16-3.288-1.912-1.904-3.413-4.38-3.376-6.248.014-.805.3-1.501.871-2 .051-.043.088-.08.14-.116.22-.19.453-.293.666-.293.212 0 .403.08.542.3l1.42 2.131c.155.227.17.484-.058.71l-.644.645c-.506.506-.47 1.12-.103 1.612.418.564 1.143 1.384 1.707 1.94.556.564 1.442 1.355 2.014 1.78.49.366 1.106.403 1.611-.102l.645-.645c.227-.227.476-.212.71-.066l2.131 1.421c.22.147.3.33.3.55 0 .212-.102.446-.292.666-.044.051-.073.088-.117.14-.498.57-1.194.849-2.007.863z",
    transform: "translate(-100 -1084) translate(80 1069) translate(20 14) translate(0 1)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCallPurple);
export default __webpack_public_path__ + "static/media/ic_call_purple.c29e4145d585e2731a4453caf4aa6f04.svg";
export { ForwardRef as ReactComponent };